export default __webpack_public_path__ + "static/media/hht1_ep07_book_wp_02.cbbdb76c.jpg";